import { render, staticRenderFns } from "./ShowMessages.vue?vue&type=template&id=7e322cf8&"
import script from "./ShowMessages.vue?vue&type=script&lang=js&"
export * from "./ShowMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports